// @ts-check

import React, { useState } from 'react';
import { number, object } from 'prop-types';
import assignAddressLabel from '../libs/assignAddressLable';
import USER from '../ts/profileEditorEnum';
import Grid from '@mui/material/Grid';
import ProfileTextField from './ProfileTextField';
import ProfileMap from './ProfileMap';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import PlaceAutocompleteModal from 'components/placeAutocompleteModal/PlaceAutocompleteModal';

/**
 * @component ProfileEditorAddress
 * @param {Object} props
 * @param {number} props.index
 * @param {ProfileEditorAddressType} props.address
 * @param {(name:string, payload: any)=>void} props.onHandle
 * @returns {JSX.Element}
 */
function ProfileEditorAddress({ index, address, onHandle }) {
	const [openMap, setOpenMap] = useState(false);
	const [openPlace, setOpenPlace] = useState(false);

	const label = assignAddressLabel(index);

	/**
	 * @function onOpenMap
	 * @returns {void}
	 */
	const onOpenMap = () => {
		setOpenMap(!openMap);
	};

	/**
	 * @function onOpenPlace
	 * @param {boolean} status
	 * @returns {void}
	 */
	const onOpenPlace = (status) => {
		setOpenPlace(status);
	};

	/**
	 * @function onDeleteAddress
	 * @returns {void}
	 */
	const onDeleteAddress = () => {
		onHandle(USER.DELETE_ADDRESS, address.type);
	};

	return (
		<>
			{address.placeId !== '' ? (
				<Grid container spacing={2}>
					<Grid item lg={5.5} xs={12}>
						<ProfileTextField label={label} value={address.street} />
					</Grid>
					<Grid item lg={1.25} xs={12}>
						<ProfileTextField label="City" value={address.city} />
					</Grid>
					<Grid item lg={1.25} xs={12}>
						<ProfileTextField label="Province" value={address.province} />
					</Grid>
					<Grid item lg={1.25} xs={12}>
						<ProfileTextField label="Country" value={address.country} />
					</Grid>
					<Grid item lg={1.25} xs={12}>
						<ProfileTextField label="Postal Code" value={address.postalCode} />
					</Grid>
					<Grid item lg={1.5} xs={12}>
						<Tooltip arrow title="Edit address">
							<IconButton onClick={() => onOpenPlace(true)}>
								<EditIcon fontSize="small" />
							</IconButton>
						</Tooltip>
						<Tooltip arrow title="Delete address">
							<IconButton onClick={onDeleteAddress}>
								<DeleteIcon fontSize="small" />
							</IconButton>
						</Tooltip>
						<Tooltip arrow title="View location">
							<IconButton onClick={onOpenMap}>
								<LocationOnIcon fontSize="small" />
							</IconButton>
						</Tooltip>
					</Grid>
				</Grid>
			) : (
				<Grid item lg={1.5} xs={12} sx={{ display: 'flex', paddingRight: '0.5rem' }}>
					<Tooltip arrow title={`Add ${label} address`}>
						<IconButton
							onClick={() => onOpenPlace(true)}
							style={{ border: 'solid 1px', marginLeft: 'auto' }}
						>
							<AddIcon fontSize="small" />
						</IconButton>
					</Tooltip>
				</Grid>
			)}
			<ProfileMap
				open={openMap}
				coordinate={{ lat: String(address.lat), lng: String(address.lng) }}
				onClose={onOpenMap}
			/>
			<PlaceAutocompleteModal
				open={openPlace}
				onOpen={onOpenPlace}
				title={label}
				onHandle={onHandle}
			/>
		</>
	);
}

ProfileEditorAddress.propTypes = { index: number, address: object };

export default ProfileEditorAddress;
